import { render, staticRenderFns } from "./LeadEnquiries.vue?vue&type=template&id=096cf776&"
import script from "./LeadEnquiries.vue?vue&type=script&lang=js&"
export * from "./LeadEnquiries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports